export enum HttpHeaders {
    XAccessToken = 'X-Access-Token',
    ContentType = 'Content-Type',
}

export enum ContentTypeValue {
    Json = 'application/json',
}
